/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_Over_PercentInputs */

const cs_deal_splits_over_percent = /** @type {(inputs: Deal_Splits_Over_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Součet procent překračuje 100 %.`)
};

const en_deal_splits_over_percent = /** @type {(inputs: Deal_Splits_Over_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split percents exceed 100%.`)
};

/**
* | output |
* | --- |
* | "Split percents exceed 100%." |
*
* @param {Deal_Splits_Over_PercentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_over_percent = /** @type {((inputs?: Deal_Splits_Over_PercentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Over_PercentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_over_percent(inputs)
	return cs_deal_splits_over_percent(inputs)
});